import {Menu} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {RrcEp10WasteManifestEntity} from "@ots-frontend/ots-data";
import {useCallback, useMemo} from "react";
import {useAuth} from "../../../providers/AuthProvider/AuthProvider";
import {IconDownload} from "@tabler/icons-react";
import {useRrcEp10WasteManifestAction} from "./useRrcEp10WasteManifestAction";

const ALL_ACTIONS = [
  "DOWNLOAD",
] as const;

export type RrcEp10WasteManifestAction = typeof ALL_ACTIONS[number];

export type RrcEp10WasteManifestActionMenuDropdownProps = {
  rrcEp10WasteManifest: RrcEp10WasteManifestEntity
  actions?: RrcEp10WasteManifestAction[]
  onActionClick?: (action: RrcEp10WasteManifestAction) => void
  showEmpty?: boolean
}

export const RrcEp10WasteManifestActionMenuDropdown = (props: RrcEp10WasteManifestActionMenuDropdownProps) => {
  const {
    rrcEp10WasteManifest,
    actions = ALL_ACTIONS,
    onActionClick,
    showEmpty = true
  } = props

  const {hasAccess} = useAuth()
  const {t} = useTranslation(["common"])

  const visibleActions: Set<RrcEp10WasteManifestAction> = useMemo(() => {
    const enabledActions = new Set<RrcEp10WasteManifestAction>()
    const actionsSet = actions ? new Set<RrcEp10WasteManifestAction>(actions) : new Set<RrcEp10WasteManifestAction>()

    if (hasAccess("rrcep10wastemanifest_view")) {
      if (actionsSet.has("DOWNLOAD")) {
        enabledActions.add("DOWNLOAD")
      }
    }

    return enabledActions
  }, [rrcEp10WasteManifest, actions, hasAccess])

  const {
    onRrcEp10WasteManifestActionClick
  } = useRrcEp10WasteManifestAction()

  const _onActionClick = useCallback((action: RrcEp10WasteManifestAction) => {
    if (onActionClick) {
      onActionClick(action)
    } else {
      onRrcEp10WasteManifestActionClick(rrcEp10WasteManifest, action)
    }
  }, [onActionClick, onRrcEp10WasteManifestActionClick, rrcEp10WasteManifest])

  return (
    <>
      {(showEmpty && visibleActions.size === 0) &&
        <Menu.Item>
          {t("common.action.none", "No Actions")}
        </Menu.Item>
      }
      {visibleActions.has("DOWNLOAD") &&
        <Menu.Item icon={<IconDownload size={14}/>} onClick={() => _onActionClick("DOWNLOAD")}>
          {t("common.action.download", "Download")}
        </Menu.Item>
      }
    </>
  )
}
